import React, { useEffect, useRef, useState } from 'react';
import { Animated } from 'react-native';
import styled from 'styled-components/native';
import { REDESIGN_COLORS } from '../../styles/colors';
import { NEGOTIATION_CONFIG } from '../../config/negotiationConfig';

// ---------- Styled components ----------

const Container = styled.View`
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  gap: 8px;
`;

const DotsRow = styled.View`
  flex-direction: row;
  align-items: center;
  background-color: rgba(5, 86, 247, 0.15);
  border-radius: 12px;
  padding: 10px 16px;
  gap: 6px;
`;

const LabelText = styled.Text`
  font-family: Satoshi-Regular;
  font-size: 13px;
  color: ${REDESIGN_COLORS.textSecondary};
  margin-left: 4px;
`;

const SlowNote = styled.Text`
  font-family: Satoshi-Regular;
  font-size: 12px;
  color: ${REDESIGN_COLORS.scoreMedium};
  margin-left: 8px;
`;

// ---------- Single animated dot ----------

const AnimatedDot = ({ delay }) => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    const animation = Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, {
          toValue: 1,
          duration: 400,
          delay,
          useNativeDriver: false,
        }),
        Animated.timing(opacity, {
          toValue: 0.3,
          duration: 400,
          useNativeDriver: false,
        }),
      ])
    );
    animation.start();
    return () => animation.stop();
  }, [opacity, delay]);

  return (
    <Animated.View
      style={{
        width: 8,
        height: 8,
        borderRadius: 4,
        backgroundColor: REDESIGN_COLORS.ctaBlue,
        opacity,
      }}
    />
  );
};

// ---------- Component ----------

const TypingIndicator = () => {
  const [showSlowNote, setShowSlowNote] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSlowNote(true);
    }, NEGOTIATION_CONFIG.DRAFT_GENERATION_TIMEOUT_MS);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Container>
      <DotsRow>
        <AnimatedDot delay={0} />
        <AnimatedDot delay={200} />
        <AnimatedDot delay={400} />
      </DotsRow>
      <LabelText>Generating draft...</LabelText>
      {showSlowNote && <SlowNote>Taking longer than expected...</SlowNote>}
    </Container>
  );
};

export default TypingIndicator;
